<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">
    <div class="layout-column flex ma-1"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">

      <div v-if="patientId">
        <patient-diagnoses v-if="showPatientBaseData" :patientId="patientId" :v-model="showPatientBaseData" :tabid="tabid" @input="setShowPatientBaseData"></patient-diagnoses>

        <patient-details v-if="!showPatientBaseData" :tabid="tabid" :patientId="patientId" @input="setShowPatientBaseData"></patient-details>
      </div>

      <div v-if="!patientId">
        <patient-details :patientId="patientId" :tabid="tabid"></patient-details>
      </div>

    </div>
  </div>
</template>

<script>
import metaData from '../../components/documentation/shared/formsMetaData'
import patientDetails from './PatientDetails'
import patientDiagnoses from './PatientDiagnoses'

export default {
  name: 'PatientDetails',
  mixins: [metaData],
  props: ['patientId', 'tabid'],
  components: {
    patientDetails,
    patientDiagnoses
  },
  data () {
    return {
      loading: false,
      showPatientBaseData: true
    }
  },
  beforeRouteUpdate (to, from, next) {
    /**
     * Notwendig, damit zwei Routen auf die gleiche Komponente gehen, die aber per Tab hin und hergeschaltet werden können und sich nur im Parameter unterscheiden
     * **/
    next()
  },
  methods: {
    setShowPatientBaseData (bool) {
      this.showPatientBaseData = bool
    }
  },
  watch: {
    '$route': {
      handler: function (to) {
        if (to?.path === '/patient/details/' + this.tabid + '/' + this.patientId) {
          const storedPatient = this.$store.getters.routingAfterReportValidation(this.patientId)

          // set view of base data, if patient has errors in base data in pre validation of report dialog
          if (storedPatient && storedPatient.showBaseData) {
            this.showPatientBaseData = false
          }

          // set view of form data, if patient has errors in forms in pre validation of report dialog
          // must set, when view is in base data
          if (storedPatient && storedPatient.showFormData) {
            this.showPatientBaseData = true
          }
        }
      },
      immediate: true
    }
  }
}
</script>
